module.exports = __webpack_public_path__ + "img/virtual_tour.b2ddc543.jpg";